import { createMuiTheme } from '@material-ui/core/styles';

const theme = createMuiTheme({
  palette: {
    background: {
      default: '#f8f7f5',
    },
    primary: {
      main: '#436c00',
    },
    secondary: {
      main: '#b1ca80',
    },
    text: {
      primary: '#000000',
    },
  },
  typography: {
    fontFamily: 'Helvetica, Arial, sans-serif',
    fontSize: 14,
  },
  overrides: {
    MuiCssBaseline: {
      '@global': {
        html: {
          scrollBehavior: 'smooth',
        },
        '::selection': {
          backgroundColor: '#F3F6ED',
        },
      },
    },
  },
});

theme.customColors = {
  brand: '#b1ca80',
  active: '#436c00',
  bullet: '#436c00',
  highlight: '#b1ca80',
  award: '#EBCA23',
  recognition: '#B4DB75',
  lavender: '#EFEEFE',
  pinkLavender: '#F0E2FF',
  darkLavender: '#A077CC',
  heavy: '#000000',
  wgDarkGreen: '#002500',
  wgMediumGreen: '#436c00',
  wgLightGreen: '#b1ca80',
  wgWhite: '#f8f7f5',
  wgLightGrey: '#bab9b6',
};

export default theme;
